import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import tblUpdateSupplier, { TblUpdateSupplier, CountUpdateRecords, Value } from '../model/tblUpdateSupplier';
import ODataFilterBuilder from 'odata-filter-builder';
import { CompanyWrGruppenResult, LieferantengruppenResult } from '@/shared/model/company';
import { CONST } from '@/shared/utils/Constants';

const logger = new Logger('backend.TblUpdateSupplier');
export interface BackendTblUpdateSupplier {
  getTblUpdateSupplier(id: string): AxiosPromise<TblUpdateSupplier>;
  getTblUpdateSuppliers: (searchParams: SearchParams, searchData?: any) => AxiosPromise<Value>;
  getAddSupplierCompleted(payload: any): AxiosPromise<any>;
  deleteTblUpdateSupplier(id: string): AxiosPromise;
  updateTblUpdateSupplier(TblUpdateSupplier: TblUpdateSupplier): AxiosPromise<any>;
  getCompanyWrGruppen(searchData?: any): AxiosPromise<CompanyWrGruppenResult[]>;
  getSuppliersCompanyWrGruppen(searchData?: any): AxiosPromise<CompanyWrGruppenResult[]>;
  getLieferantengruppen(searchData?: any): AxiosPromise<LieferantengruppenResult[]>;
  getLieferantengruppenFilter(searchData?: any): AxiosPromise<LieferantengruppenResult[]>;
  getCanselSupplierCompleted(payload: any): AxiosPromise<any>;
}

export const defaultBackendTblUpdateSupplier: BackendTblUpdateSupplier = {
  getTblUpdateSupplier(id: string): AxiosPromise<TblUpdateSupplier> {
    let url = `${URLS.tblUpdateSupplierOdata}/${id}`;
    return instance.get<TblUpdateSupplier>(url);
  },
  getTblUpdateSuppliers(searchParams: SearchParams, searchData?: any): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    // odfb.eq(CONST.OrganisationId, organisationId, false);
    let url = DefaultBackendHelper.makeUrl(
      `${URLS.tblUpdateSupplierOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );
    logger.log(`getTblUpdateSuppliers${url}`);
    return instance.post<Value>(url, searchData);
  },
  deleteTblUpdateSupplier(id: string): AxiosPromise {
    logger.debug('deleteTblUpdateSupplier');
    return instance.delete(`${URLS.tblUpdateSupplier}/${id}`);
  },
  updateTblUpdateSupplier(TblUpdateSupplier: TblUpdateSupplier): AxiosPromise<any> {
    logger.debug('updateTblUpdateSupplier');
    return instance.put<TblUpdateSupplier>(
      `${URLS.tblUpdateSupplier}/update`,
      tblUpdateSupplier.toAPI(TblUpdateSupplier)
    );
  },
  getAddSupplierCompleted(data: any): AxiosPromise<any> {
    return instance.put(`${URLS.tblUpdateSupplier}/AddSupplierCompleted`, data);
  },
  getCanselSupplierCompleted(data: any): AxiosPromise<any> {
    return instance.put(`${URLS.tblUpdateSupplier}/CanselSupplierCompleted`, data);
  },
  getCompanyWrGruppen(searchData?: any): AxiosPromise<CompanyWrGruppenResult[]> {
    return instance.post<CompanyWrGruppenResult[]>(`${URLS.tblUpdateSupplier}/GetCompanyWrGruppen`, searchData);
  },
  getSuppliersCompanyWrGruppen(searchData?: any): AxiosPromise<CompanyWrGruppenResult[]> {
    return instance.post<CompanyWrGruppenResult[]>(
      `${URLS.tblUpdateSupplier}/GetSuppliersCompanyWrGruppen`,
      searchData
    );
  },
  getLieferantengruppen(searchData?: any): AxiosPromise<LieferantengruppenResult[]> {
    return instance.post<LieferantengruppenResult[]>(`${URLS.tblUpdateSupplier}/GetLieferantengruppen`, searchData);
  },
  getLieferantengruppenFilter(searchData?: any): AxiosPromise<LieferantengruppenResult[]> {
    return instance.post<LieferantengruppenResult[]>(
      `${URLS.tblUpdateSupplier}/GetLieferantengruppenFilter`,
      searchData
    );
  },
};
